import React from 'react'
import Style from './index.style'

const CardLong = ({
  options,
  shadow = false,
  border = false,
  imageAuto = false,
  padding = '30px 24px',
  imageSize = '109px',
  hover = false
}) => {
  return (
    <Style
      className="card-long-box"
      hover={hover}
      padding={padding}
      imageAuto={imageAuto}
      shadow={shadow}
      border={border}
      imageSize={imageSize}
    >
      <img
        src={options.image}
        alt="halojasa/service"
        className="card-long-image glass-hover"
      />
      <div className="text">
        <h4 className="h4">{options.title}</h4>
        <p>{options.desc}</p>
      </div>
    </Style>
  )
}

export default CardLong
